module.exports = __webpack_public_path__ + "img/PPMP34.e3efd52f.png";